
import { createWithEqualityFn } from "zustand/traditional";

interface AdminLoginOtpState {
  isVerifyingOTP: boolean;
  userId: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  otpToken: string | null;
  otpMethod: "sms" | "email";

  // Actions
  setUserId: (userId: string) => void;
  setEmailAddress: (emailAddress: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  setOtpToken: (otpToken: string) => void;
  setOtpMethod: (method: "sms" | "email") => void;
  setIsVerifyingOTP: (isVerifyingOTP: boolean) => void;
  reset: () => void;
}

const initialState = {
  userId: null,
  emailAddress: null,
  phoneNumber: null,
  otpToken: null,
  otpMethod: "sms" as "sms" | "email",
  isVerifyingOTP: false
};

export const useAdminLoginOtpStore = createWithEqualityFn<AdminLoginOtpState>((set) => ({
  ...initialState,
  setIsVerifyingOTP: (isVerifyingOTP: boolean) => set({ isVerifyingOTP }),
  setUserId: (userId: string) => set({ userId }),
  setEmailAddress: (emailAddress: string) => set({ emailAddress }),
  setPhoneNumber: (phoneNumber: string) => set({ phoneNumber }),
  setOtpToken: (otpToken: string) => set({ otpToken }),
  setOtpMethod: (method: "sms" | "email") => set({ otpMethod: method }),
  reset: () => set(initialState),
}));
